<template>
  <VBlock v-if="isShow" class="loading-container" :sort="Sort.center_center">
    <LoadingAndroid v-show="isAndroid" />
    <LoadingIOS v-show="!isAndroid" />
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

import LoadingAndroid from '@/presentationals/v2/components/layouts/organisms/LoadingAndroid'
import LoadingIOS from '@/presentationals/v2/components/layouts/organisms/LoadingIOS'

export default {
  name: 'Loading',
  props: {
    isAndroid: {
      type: Boolean,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VBlock,

    LoadingAndroid,
    LoadingIOS
  },
  data() {
    return {
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background-color: $background-white;
}
</style>